import script from "./FindASpace.vue?vue&type=script&setup=true&lang=js"
export * from "./FindASpace.vue?vue&type=script&setup=true&lang=js"

import "./FindASpace.vue?vue&type=style&index=0&id=058c1c7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058c1c7d"]])

export default __exports__